/**
* @author Camilo
* @since  15/11/2017
**/
export class DetalleFacturaModel{

    constructor(public cdescon:string, public ccodcon:string, public nvalbase:number, public nvaliva:number, public nimpuestoconsumo:number, public nvalbaseapli:number, public nvalivaapli:number,public nimpuestoconsumoapli:number, public nidreg:number, public nregconcep:number,public dfecmov:Date, public unidades:number,public nporcentaje:number,public ndescuento:number){}

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Notas/DetalleFactura.model.ts